import { TOKEN_TYPE } from "../TokenType.js";
import Token from "../Token.js";

export default class RightParenthesisToken extends Token {
    constructor( value ) {
        super( TOKEN_TYPE.RIGHT_PARENTHESIS, value );
    }
}
